import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { CourseService } from './course.service';
import { CourseVendor } from './course-vendor.model';

@Injectable({
  providedIn: 'root'
})
export class CourseVendorsService {
    isLoading:boolean = false;
    isAdd:boolean = false;
    isEditable:boolean = false;
    errorMessage:string = '';
    courseVendors: CourseVendor[];

    constructor(
        private apiService: ApiService,
        private courseService: CourseService
    ) {}

    get(): void {
        this.errorMessage = '';
        this.isLoading = true;

        this.apiService.getCourseVendors(this.course).subscribe(
            (data) => {
                this.courseVendors = data.map(courseVendor => {return new CourseVendor(courseVendor);});
                this.isLoading = false;
            },
            (error) => {
                this.isLoading = false;
                this.courseVendors = [];
                this.errorMessage = 'An error occurred, and we were unable to load Vendors for this Course.';
            }
        );
    }

    get course() {
        return this.courseService.course;
    }

}
